import React, { useState } from "react";
import { useAppText } from "src/commun/composants/AppText";
import { useFormikContext } from "formik";
import AppRow from "src/commun/composants/grille/AppRow";
import AppInput from "src/commun/composants/formulaire/AppInput/AppInput";
import AppInputFormik from "src/commun/composants/formulaire/formik/fields/AppInputFormik";
import { useAppState } from "src/app/state/StateProvider";
import { CheckTelephoneCode } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneCheck/useValidationSchemaTelephoneCode";
import { sendCodeTelephone } from "src/app/api/PublicApi";
import { AxiosError } from "axios";
import AppMessage from "src/commun/composants/AppMessage/AppMessage";

export type CodeTelephoneCheckFormContentProps = {
  stepPrecedente: () => void;
  pageSuivante?: (data: any) => void;
  canSkip?: boolean;
  setCustomError: (err: AxiosError | undefined) => void;
  displayCancelBtn?: boolean;
  cancelCallback?: () => void;
};

const CodeTelephoneCheckFormContent = ({ stepPrecedente, pageSuivante, canSkip, setCustomError, displayCancelBtn, cancelCallback }: CodeTelephoneCheckFormContentProps) => {
  const { tString } = useAppText();
  const { values, submitCount, submitForm } = useFormikContext<CheckTelephoneCode>();
  const [{ langue }] = useAppState();
  const [askNewCode, setAskNewCode] = useState(false);

  const handleSendCodeAgain = () => {
    sendCodeTelephone({mobileNumber: values.mobileNumber}, langue)
      .then(() => {
        setAskNewCode(true);
        setCustomError(undefined)
      })
      .catch(err => {
        setAskNewCode(false);
        setCustomError(err);
      });
  }

  return (
    <>
      {askNewCode &&
        <div className="mb-3">
            <AppMessage messageType="INFO" children={<>{tString("compte.mon.profile.email.code.renvoye")}</>} />
        </div>
      }
      <div className="input btn__filter--disabled">
        <AppInput name="mail" value={values.mobileNumber} onChange={() => {}} disabled />
      </div>
      <div className="input mt-3 ">
        <AppInputFormik
          name="code"
          type="text"
          maxLength={35}
          iconVerif={false}
          formulaireSoumis={submitCount > 0}
        />
        <label>{tString("compte.mon.profile.mobile.code.recu")}</label>
      </div>
      <div className="mt-3 paragraph--gray">
        <p className="txt-underline cursor-pointer" onClick={handleSendCodeAgain}>{tString("compte.mon.profile.mobile.code.non.recu")}</p>
      </div>
      <AppRow>
        <input
          className="btn__primary mt-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={submitForm}
          value={tString("action.verifier.code.validation")}
        />
      </AppRow>
      <AppRow>
        <input
          className="btn__primary mt-3 mr-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={stepPrecedente}
          value={tString("action.modifier.telephone")}
        />
        {canSkip &&
            <input
                className="btn__primary mt-3 btn--full--xs"
                type="submit"
                name="skip"
                onClick={pageSuivante}
                value={tString("compte.mon.profile.mobile.saisi.non.souhaite")}
            />
        }
        {displayCancelBtn &&
            <input
                className="btn__primary mt-3 btn--full--xs"
                type="submit"
                name="annuler"
                onClick={cancelCallback}
                value={tString("update.mobile.cancel.button")}
            />
        }
      </AppRow>

    </>
  );
};

export default CodeTelephoneCheckFormContent;